import { Tag } from 'antd';
import type { StatusConfig } from '../constants/statusMappings';

/**
 * 通用状态标签渲染
 */
export const renderStatusTag = (
  status: string,
  mapping: Record<string, StatusConfig>,
  fallbackText?: string,
) => {
  const config = mapping[status] || { color: 'default', text: fallbackText || status };
  return <Tag color={config.color}>{config.text}</Tag>;
};
